import http from '../plugins/http'
import {SYSTEM_CONFIG} from '../config/config_api_backend'
import stringInject from 'stringinject'
import {ContentType} from '../constants/DoITConstant'

const apiGetAllSetting = async (params) => {
    let response = await http.get(SYSTEM_CONFIG.GET_SETTING_ALL, {
        params: params,
    },)
    return response.data
}

const apiGetAllMailHistory = async (params) => {
    let response = await http.get(SYSTEM_CONFIG.GET_MAIL_HISTORY_ALL, {
        params: params,
    },)
    return response.data
}

const apiUpdateSetting = async (key, value) => {
    const formData = new FormData()
    formData.append('value', value)
    let url = stringInject(SYSTEM_CONFIG.UPDATE_SETTING, {'key': key})
    let response = await http.post(url, formData, {'Content-Type': ContentType.formData})
    return response.data
}

export {
    apiGetAllSetting,
    apiUpdateSetting,
    apiGetAllMailHistory
}
